import { Audience } from '@fluidx/office-fluid-types';

const audienceMapping = new Map<Audience, number>([
  ['Automation', 0],
  ['Local', 1],
  ['Staging', 2],
  ['Dogfood', 3],
  ['Preview', 4],
  ['Microsoft', 5],
  ['SyntheticTraffic', 5],
  ['Production', 6],
  ['GCC', 7],
  ['GCC-High', 8],
  ['DoD', 8]
]);

/**
 * Helper function to enable features up to a specific environment.
 * 'Automation' < 'Local' < 'Staging' < 'Dogfood' < 'Preview' < 'Microsoft'  === 'SyntheticTraffic' < 'Production' < 'GCC' < 'GCC-High' === 'DoD'
 * @returns true if the Audience value represents an audience below the one stated, false otherwise. If audience is undefined, we assume production
 */
export function enableUpToAudience(enableUpTo: Audience, audience: Audience | undefined): boolean {
  let audienceToUse = audience;
  if (audienceToUse === undefined) {
    audienceToUse = 'Production'; // If audience is undefined, we assume production to be safe.
  }

  const enableUpToValue = audienceMapping.get(enableUpTo);
  const audienceValue = audienceMapping.get(audienceToUse);

  return enableUpToValue !== undefined && audienceValue !== undefined && audienceValue <= enableUpToValue;
}
